<template>
  <UserCompanyDetail  v-bind:userId="user_id" v-bind:companyFlag="companyFlag"/>
</template>
<script>
// import UserCompanyDetail from '../userDetail/component/tabs/company/UserCompanyDetail';
import UserCompanyDetail from '../common/UserCompanyDetail';

export default {
    name: "companyUserManagementDetail",
    data() {
        return {
            user_id: "",
            companyFlag: "D",   // D 상세화면, R 등록화면
        }
    },
    components: {
        UserCompanyDetail,
    },
    mounted() {
        this.user_id = this.$session.get('usermanage_user_id');
        if(this.user_id === '') {
            // console.log(this.user_id);
            this.companyFlag = "R";
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/views/user/companyUserList/CompanyUserManagementDetail.vue